var SIGN_REGEXP = /([yMdhsm])(\1*)/g
var DEFAULT_PATTERN = 'yyyy-MM-dd'
function padding(s, len) {
    var len = len - (s + '').length
    for (var i = 0; i < len; i++) {
        s = '0' + s
    }
    return s
}

export default {
    getQueryStringByName: function(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
        var r = window.location.search.substr(1).match(reg)
        var context = ''
        if (r != null) context = r[2]
        reg = null
        r = null
        return context == null || context == '' || context == 'undefined' ? '' : context
    },
    formatDate: {
        //将时间对象格式化为固定格式化字符串
        format: function(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN
            return pattern.replace(SIGN_REGEXP, function($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length)
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length)
                    case 'd':
                        return padding(date.getDate(), $0.length)
                    case 'w':
                        return date.getDay() + 1
                    case 'h':
                        return padding(date.getHours(), $0.length)
                    case 'm':
                        return padding(date.getMinutes(), $0.length)
                    case 's':
                        return padding(date.getSeconds(), $0.length)
                }
            })
        },
        //将时间字符串,转化为时间对象
        parse: function(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP)
            var matchs2 = dateString.match(/(\d)+/g)
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1)
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i])
                    var sign = matchs1[i]
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int)
                            break
                        case 'M':
                            _date.setMonth(_int - 1)
                            break
                        case 'd':
                            _date.setDate(_int)
                            break
                        case 'h':
                            _date.setHours(_int)
                            break
                        case 'm':
                            _date.setMinutes(_int)
                            break
                        case 's':
                            _date.setSeconds(_int)
                            break
                    }
                }
                return _date
            }
            return null
        },
        //将时间字符串或者时间对象 格式化为 yyyy-MM-dd
        formatSimple(tObj) {
            if (tObj == null || tObj == '') {
                return ''
            } else {
                if (typeof tObj == 'string') {
                    tObj = tObj.replace(/\-/g, '/')
                }
                var tim = new Date(tObj)
                var year = tim.getFullYear() //年
                var month = tim.getMonth() + 1 //月
                month = month < 10 ? '0' + month : month
                var day = tim.getDate() //日
                day = day < 10 ? '0' + day : day
                return year + '-' + month + '-' + day
            }
        },

        /**
         * 将毫秒数格式化为yyyy-MM-dd HH:mm:ss
         * @returns
         */
        formatMillisecondToDate(tObj) {
            if (tObj == null || tObj == '') {
                return ''
            } else {
                var tim = new Date(tObj)
                var year = tim.getFullYear() //年
                var month = tim.getMonth() + 1 //月
                month = month < 10 ? '0' + month : month
                var day = tim.getDate() //日
                day = day < 10 ? '0' + day : day
                var hour = tim.getHours()
                var minute = tim.getMinutes()
                var second = tim.getSeconds()
                hour = hour < 10 ? '0' + hour : hour
                minute = minute < 10 ? '0' + minute : minute
                second = second < 10 ? '0' + second : second
                return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + second
            }
        }
    },
    //判断字符串是否为空
    isBlackStr(str) {
        if (!str || $.trim(str) == '') return true
        return false
    },
    //是否手机号的正则校验
    isPhoneNumber(str) {
        //if(/^((13[0-9])|(14[5|7|9])|(15([0-3]|[5-9]))|(18[0-9])|(17[0-9]))\d{8}$/.test(str))
        if (/^[1][1,2,3,4,5,6,7,8,9][0-9]{9}$/.test(str)) {
            return true
        }
        return false
    },

     //统一社会信用代码
     isSocialCreditCode(str) {
        if (/[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/.test(str))
            return true;
        return false;
    },
    /**
 * 字符串对象是否为空
 * @param str
 * @returns
 */strIsBlank(str){
    if(!str || $.trim(str)===""){
        return true;
        }
        return false;
    },
    //是否是正整数
    isPositiveInteger(str) {
        if (/^[0-9]+$/.test(str)) return true
        return false
    },
    //大于零的浮点数校验 小数点两位最多两位小数,并且整数位不能超过8位
    isfloatingPoint(str) {
        if (/^\d{1,8}(\.\d{1,2})?$/.test(str)) return true
        return false
    },
    //是否是身份证号码
    isIdCard(str) {
        if (str) {
            if (str.length === 15) {
                if (/^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/.test(str)) {
                    return true
                }
            } else if (str.length === 18) {
                if (/^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[A-Za-z])$/.test(str)) {
                    return true
                }
            }
        }
        return false
    },
    //是否是邮箱
    isEmail(str) {
        if (/^([a-z0-9A-Z]+[-|\\.]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}$/.test(str)) return true
        return false
    },
    //密码格必须包含字母与数字
    isPassword(str) {
        if (/^(?=.*[a-zA-Z])(?=.*\d)[^]{6,20}$/.test(str)) return true
        return false
    },
    //过滤富文本编辑器的html标签
    filterHtmlTag(str) {
        if (str) {
            str = str.replace(/(\n)/g, '')
            str = str.replace(/(\t)/g, '')
            str = str.replace(/(\r)/g, '')
            str = str.replace(/<\/?[^>]*>/g, '')
            str = str.replace(/\s*/g, '')
            str = str.replace(/&nbsp;/g, '')
            return str
        }
        return ''
    },
    /** 获取uuid */
    UUID() {
        var s = []
        var hexDigits = '0123456789abcdef'
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1)
        }
        s[14] = '4'
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1)
        s[8] = s[13] = s[18] = s[23] = '-'

        var uuid = s.join('')
        return uuid
    },
    /**
     * 将带有parentId字段的json，转换成带有children格式
     * @param list  要转化的json
     * @param idstr id字段名
     * @param pidstr 父级字段名
     */
    parentToChild(list, idstr, pidstr) {
        var result = []
        var temp = {}
        for (var i = 0; i < list.length; i++) {
            temp[list[i][idstr]] = list[i] // 将nodes数组转成对象类型
        }
        for (var j = 0; j < list.length; j++) {
            var tempVp = temp[list[j][pidstr]] // 获取每一个子对象的父对象
            if (tempVp) {
                // 判断父对象是否存在，如果不存在直接将对象放到第一层
                if (!tempVp['children']) tempVp['children'] = [] // 如果父元素的nodes对象不存在，则创建数组
                tempVp['children'].push(list[j]) // 将本对象压入父对象的nodes数组
            } else {
                result.push(list[j]) // 将不存在父对象的对象直接放入一级目录
            }
        }
        return result
    },
    /**
     * 将url中的html字符转义， 仅转义  ', ", <, > 四个字符
     * @param  { String } str 需要转义的字符串
     * @param  { RegExp } reg 自定义的正则
     * @return { String }     转义后的字符串
     */
    unhtmlForUrl: function(str, reg) {
        return str
            ? str.replace(reg || /[&<">'](?:(amp|lt|quot|gt|#39|nbsp|#\d+);)?/g, function(a, b) {
                  if (b) {
                      return a
                  } else {
                      return {
                          '<': '&2526lt;',
                          '&': '&amp;',
                          '"': '&quot;',
                          '>': '&2526gt;',
                          "'": '&#39;'
                      }[a]
                  }
              })
            : ''
    },
    /**
     * 将str中的转义字符还原成html字符
     * @see UE.utils.unhtml(String);
     * @method html
     * @param { String } str 需要逆转义的字符串
     * @return { String } 逆转义后的字符串
     * @example
     * ```javascript
     *
     * var str = '&lt;body&gt;&amp;&lt;/body&gt;';
     *
     * //output: <body>&</body>
     * console.log( UE.utils.html( str ) );
     *
     * ```
     */
    html: function(str) {
        str = str
            ? str.replace(/&amp;/g, function(m) {
                  return {
                      '&amp;': '&'
                  }[m]
              })
            : '';
        str= str
            ? str.replace(/&(2526gt|2526lt|quot|amp|#39|nbsp);/g, function(m) {
                  return {
                      '&2526lt;': '<',
                      '&amp;': '&',
                      '&quot;': '"',
                      '&2526gt;': '>',
                      '&#39;': "'",
                      '&nbsp;': ' '
                  }[m]
              })
            : '';
        return str
            ? str.replace(/%(2526gt|2526lt|quot|amp|#39|nbsp|2526nbsp|26nbsp);/g, function(m) {
                return {
                    '%2526lt;': '<',
                    '%amp;': '&',
                    '%quot;': '"',
                    '%2526gt;': '>',
                    '%#39;': "'",
                    '%nbsp;': ' ',
                    '%2526nbsp;': ' ',
                    '%26nbsp;': ' '
                }[m]
            })
            : '';
    }
}



// WEBPACK FOOTER //
// ./src/js/util.js